// Reducers

const initialState = {
    members: [],
    currentUser: {}, // { id: "...", token: "..." }
    profile: {}, // { id, email,... }
    schedule: [],
    memberNameMap: {},
    memberIdMap: {},
    hub: {},
    unreadMessages: {},
    shouldAllowWindowAutoClose: true,
    shouldTurnFlashOn: false,
    //shouldDisplayChat: false,
};

function constructUnreadMessages(state, userId, isRead) {
    var newState = { ...state }
    newState['unreadMessages'][userId] = isRead
    return newState;
}

function constructMemberMaps(members) {
    var memberMapIdToMember = {};
    var memberMapNameToMember = {};
    for (var i = 0; i < members.length; i++) {
        var member = members[i];
        var memberName = member.firstName + " " + member.lastName;
        memberMapNameToMember[memberName] = member;
        memberMapIdToMember[member['id']] = member;
    }
    return [memberMapNameToMember, memberMapIdToMember];
}

function toggleUserState(state, action) {
    var newSchedules = [];
    for (var i = 0; i < state.schedule.length; i++) {
        var currentSchedule = state.schedule[i];
        if (currentSchedule['company'] === action['payload']['company']) {
            var indexOfUserId = currentSchedule['checkedUserIds'].indexOf(action['payload']['userId']);
            if (indexOfUserId !== -1) {
                currentSchedule['checkedUserIds'] = currentSchedule['checkedUserIds'].filter(val => val !== action['payload']['userId']);
            } else {
                currentSchedule['checkedUserIds'].push(action['payload']['userId']);
            }
        }
        newSchedules.push(currentSchedule);
    }

    return newSchedules;
}

function reducers(state = initialState, action) {
    switch (action.type) {
        case 'LOGIN_USER': // this is loaded right after logging in
            console.log("[reducers.js] LOGIN ACTION in reducer");
            console.log("[reducers.js] action in reducer: ", action); // {type: "LOGIN_USER", payload: {id: "...", token: "...", tokenExpirationTime: 1243}}
            console.log("[reducers.js] { ...state, currentUser: action.payload }", { ...state, currentUser: action.payload }); // {members: [{38}], currentUser: {id, token, tokenExpirationTime}, profile: {empty!}}
            return { ...state, 'currentUser': action.payload }
        case 'DATA_LOADED': // this is loaded before logging in
            var memberMaps = constructMemberMaps(action.payload);
            console.log("[reducers.js] DATA_LOADED action.payload: ", action.payload);
            console.log("[reducers.js] DATA_LOADED member map: ", memberMaps);
            return { ...state, members: action.payload.slice(0), memberNameMap: memberMaps[0], memberIdMap: memberMaps[1] }
        case 'LOAD_SCHEDULE':
            console.log("[reducers.js] LOAD_SCHEDULE action: ", action);
            return { ...state, schedule: action.payload };
        case 'TOGGLE_EMAIL_LIST_USER':
            console.log("[reducers.js] TOGGLE_EMAIL_LIST_USER action: ", action);
            return { ...state, schedule: toggleUserState(state, action) };
        case 'LOGOUT_USER':
            return { ...state, currentUser: {} };
        case 'PROFILE_LOAD':
            console.log("[reducers.js] PROFILE LOAD CALLED");
            console.log("[reducers.js] PROFILE_LOAD action: ", action);
            return { ...state, profile: action.payload };
        case 'INITIATE_CONNECTION':
            console.log("INITIATE_CONNECTION", action);
            return { ...state, hub: action.payload['connection'] }
        case 'UNREAD_MESSAGE':
            console.log("Setting UNREAD for " + action.payload);
            return constructUnreadMessages(state, action.payload['post']['payload']['userId'], true);
        case 'READ_MESSAGE':
            console.log("Setting READ for " + action.payload.userId);
            console.log(constructUnreadMessages(state, action.payload.userId, false));
            return constructUnreadMessages(state, action.payload.userId, false);
        case 'UNREAD_MESSAGE_FETCH':
            console.log("GET UNREAD MESSAGES");
            console.log(action.payload);
            var tempState = { ...state };
            for (var i = 0; i < action.payload.length; i++) {
                tempState = constructUnreadMessages(tempState, action.payload[i], true);
            }
            return tempState;
        case 'UNREAD_MESSAGE_USER_FETCH':
            console.log("GET UNREAD MESSAGE USERS");
            console.log(action.payload);
            //tbd
            return tempState;
        case 'TAB_INDEX':
            console.log("Tab index called");
            console.log("TAB INDEX ACTION", action);
            return { ...state, currentTabIndex: action.payload['tabIndex'] }
        case 'SET_BULLETIN':
            console.log("Setting bulletin");
            console.log(action);
            return { ...state, 'shouldDisplayBulletin': action.payload['shouldDisplay'] }
        case 'SET_USER_MANAGER':
            console.log("Setting user manager");
            console.log(action);
            return { ...state, 'shouldDisplayUserManager': action.payload['shouldDisplay'] }
        case 'SET_CHAT_DISPLAY':
            console.log("Setting chat display");
            return { ...state, 'shouldDisplayChat': action.payload['shouldDisplay'] }
        case 'SET_ICON_FLASH':
            console.log("Setting icon flash to...");
            console.log(action);
            console.log(action.payload['shouldTurnFlashOn']);
            return { ...state, 'shouldTurnFlashOn': action.payload['shouldTurnFlashOn'] }
        case 'ALLOW_WINDOW_AUTO_CLOSE':
            //console.log(action.payload);
            return { ...state, 'shouldAllowWindowAutoClose': action.payload['windowAutoClose'] }
        case 'SET_DISCONNECTED':
            var newProfile = state.profile;
            newProfile['status'] = 'Disconnected';
            newProfile['inOffice'] = false;
            console.log(newProfile);
            return { ...state, 'profile': newProfile }
        case 'SET_GROUP_MANAGER':
            console.log("Setting group manager");
            console.log(action);
            return { ...state, 'shouldDisplayGroupManager': action.payload['shouldDisplay'] }
        default:
            console.log("DEFAULT STATE RETURNED! ", action.type);
            return state;
    }
}

export default reducers;


// WEBPACK FOOTER //
// ./src/reducers/reducers.js


// WEBPACK FOOTER //
// ./src/reducers/reducers.js